import React from 'react';
import { CaretUpIcon, CaretDownIcon, CheckmarkIcon } from '../../../../../../../components/icons/app';
import { Tooltip } from '../../../../../../../components';

export const getCriteriaIcon = (criteria) => {
    const iconMap = {
        undersized: (
            <Tooltip className="table-criteria-icon" title="Undersized" placement="right">
                <CaretDownIcon />
            </Tooltip>
        ),
        oversized: (
            <Tooltip className="table-criteria-icon" title="Oversized" placement="right">
                <CaretUpIcon />
            </Tooltip>
        ),
        ready: (
            <Tooltip className="table-criteria-icon" title="Optimized" placement="right">
                <CheckmarkIcon />
            </Tooltip>
        ),
        can_modernize_os: (
            <Tooltip className="table-criteria-icon" title="OS Modernization Available" placement="right">
                <CaretUpIcon />
            </Tooltip>
        ),
    };
    return iconMap[criteria] || null;
};
